import React from 'react';
import PropTypes from 'prop-types';
import onlyUpdateForKeys from 'recompose/onlyUpdateForKeys';
import compose from 'recompose/compose';
import FuseTheme from '../global/theme';

const styles = {
    desc: {
        display: 'block',
        fontSize: '14px',
        color: FuseTheme.palette.accent3Color,
        margin: '0 16px 1em 16px',
    }
};

/**
 * A description block for AOR List, Show, Create and Edit overrides.
 *
 * @param record
 * @param desc
 * @return {*}
 * @constructor
 */
const PageDescription = ({ record, desc }) => {
    if (!desc) {
        return null;
    }
    return <span className="desc" style={styles.desc}>{desc}</span>;
};

PageDescription.propTypes = {
    record: PropTypes.object,
    desc: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

const enhance = compose(
    onlyUpdateForKeys('record', 'text')
);

export default enhance(PageDescription);



// WEBPACK FOOTER //
// ./src/Fuse/components/PageDescription.js